<template>
  <v-row>
    <v-sheet
      outlined
      class="mr-4 ml-4 pt-3 pb-3 rounded-sm"
      width="100vw">
      <v-col v-if="show" class="pa-4">
        <v-row class="d-flex flex-wrap align-center justify-center">
          <div
            v-for="type_sponsor in types_sponsors"
            v-bind:key="type_sponsor.id">

            <div class="d-flex flex-wrap align-center justify-center my-auto" v-if="type_sponsor.is_visible">
              <h4 class="d-flex align-center font-weight-regular pa-4">{{ type_sponsor.name }}:</h4>
              <div 
                v-for="sponsor in type_sponsor.sponsors" 
                :key="sponsor.id">

                <v-row class="d-flex align-center my-auto">
                  <a :href="sponsor.web" target="_blank">
                    <v-img
                      v-bind:src="sponsor.url_logo"
                      max-height="54px"
                      max-width="118px"
                      contain
                      class="ma-1"
                    />
                  </a>
                </v-row>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-sheet>
  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardFeaturedSponsors',
    props:['types_sponsors'],

    data: () => ({
      show: false,
      url_logo:null,
      base_url: null
    }),

    methods:{
      setData(){
        this.types_sponsors.forEach(types_sponsor => {
          types_sponsor.sponsors.forEach(sponsor => {
            sponsor.url_logo = APP_URL + sponsor.url_logo
          })
        });
        this.show = true
      }
    },
    created() {
      this.setData()
    }
  }
</script>

<style scoped>

.v-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px!important; /* Espacio entre filas */
}

.v-img {
  max-width: 90%; /* Asegura que la imagen no se extienda más allá de su contenedor */
  height: auto; /* Ajusta la altura automáticamente */
}

.card {

  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>